import { ExclamationCircleIcon, InformationCircleIcon, ShieldExclamationIcon } from "@heroicons/react/solid";
import Tippy from "@tippyjs/react";
import "tippy.js/themes/light.css";
import "tippy.js/animations/shift-away-subtle.css";

import { AUDIT_LOG_SEVERITY, SEVERITY_STYLES } from "./AuditLogData";

function formatTimestamp(isoString) {
    if (!isoString || isoString === "N/A") return "—";

    const date = new Date(isoString);

    return date.toLocaleString("en-AU", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    });
}

function SeverityIcon({ severity }) {
    switch (severity) {
        case AUDIT_LOG_SEVERITY.CRITICAL:
            return <ShieldExclamationIcon className="block h-4 w-4 text-red-600" />;
        case AUDIT_LOG_SEVERITY.ERROR:
            return <ExclamationCircleIcon className="block h-4 w-4 text-red-500" />;
        case AUDIT_LOG_SEVERITY.WARNING:
            return <ExclamationCircleIcon className="block h-4 w-4 text-amber-500" />;
        default:
            return <InformationCircleIcon className="block h-4 w-4 text-green-500" />;
    }
}

function AuditLogRow(props) {
    const { item: log } = props;

    const severityStyle = SEVERITY_STYLES[log.severity] ?? "text-slate-600 bg-slate-100";

    return (
        <tr key={log.id}>
            <td className="px-4 py-3 whitespace-nowrap">
                <div className="flex flex-row gap-3 items-start">
                    <div className="mt-0.5 flex-shrink-0">
                        <Tippy
                            content={<span>{log.description}</span>}
                            className={"p-2 shadow rounded-md text-slate-700 bg-white text-sm max-w-xs"}
                            arrow={false}
                            animation={"shift-away-subtle"}
                        >
                            <div className="cursor-pointer">
                                <SeverityIcon severity={log.severity} />
                            </div>
                        </Tippy>
                    </div>
                    <div>
                        <div className="text-sm font-medium text-indigo-900">{log.event}</div>
                        <div className="text-xs text-slate-400 mt-1 font-mono">{log.id}</div>
                    </div>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className="text-sm text-blue-gray-500">{log.user}</div>
                {log.ipAddress && log.ipAddress !== "N/A" && (
                    <div className="text-xs text-slate-400 mt-1 font-mono">{log.ipAddress}</div>
                )}
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <span className={"text-sm text-primary-900 font-medium"}>{log.category}</span>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <span className={"text-xs font-medium p-1 px-2 rounded-full " + severityStyle}>{log.severity}</span>
            </td>
            <td className="px-4 py-3 whitespace-nowrap">
                <div className="text-sm text-blue-gray-500 font-mono">{formatTimestamp(log.timestamp)}</div>
            </td>
        </tr>
    );
}

export default AuditLogRow;
